/* eslint-disable no-shadow */
import React from 'react';
import Select from '@Components/Select';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import find from 'lodash/find';

export const OptionSwitch = Object.freeze({
  ON: 'true',
  OFF: 'false',
});

export const getOptionsByName = (optionName, resp = []) => {
  const optionSet = find(resp, (optionSet) => optionSet && optionSet.name === optionName) || [];
  return (optionSet && optionSet.values) || [];
};

export const getCheckedOption = (optionName, resp = []) => {
  const options = getOptionsByName(optionName, resp);
  return find(options, (option) => (!isUndefined(option.checked) ? option.checked : option.defaultValue));
};

export const getOptionByValue = (optionName, value, resp = []) => {
  const options = getOptionsByName(optionName, resp);
  return find(options, (option) => option && option.value === value);
};

export const getCheckedValue = (optionName, resp = []) => {
  const checkedOption = getCheckedOption(optionName, resp);
  return checkedOption && checkedOption.value;
};

export function PopupRow({ children, className }) {
  return <div className={cn('rs-column', className)}>{children}</div>;
}

export function ReadOnlyRow({ children, className }) {
  return <div className={cn('rs-readonly-row', className)}>{children}</div>;
}

export function RsDropdown({ options, onChange = () => null, value, e2eName = '' }) {
  if (isEmpty(options)) {
    return null;
  }
  return (
    <Select
      className={`e2eName-${e2eName}`}
      size="xs"
      options={options}
      value={value}
      defaultValue={{ ...value }}
      fillDropdownIndicator={false}
      selectOptionHandler={(option) => onChange(option)}
      e2eName={e2eName}
    />
  );
}
